import { TypeNameEnum } from '__generated__/types';
import { POSITION_NAMES_ENGLISH_ONLY } from 'config/regions/features';
import { ServiceType } from 'interfaces';

import certificates from './certificates';

export const packagingTranslated = 'Packaging / Verpackung';

// Default names when adding non-part positions on OI, OC, II: English only for some regions (e.g. SG)
const packagingDefaultName = POSITION_NAMES_ENGLISH_ONLY ? 'Packaging' : packagingTranslated;
const transportDefaultName = POSITION_NAMES_ENGLISH_ONLY ? 'Transportation cost' : 'Transportation cost / Versand';
const customClearanceDefaultName = POSITION_NAMES_ENGLISH_ONLY ? 'Custom clearance' : 'Custom clearance / Verzollung';

const minOrderChargeDefaultName = POSITION_NAMES_ENGLISH_ONLY
  ? 'Minimum Quantity Surcharge'
  : 'Minimum Quantity Surcharge / Mindermengenzuschlag';

const serviceDefaultName = POSITION_NAMES_ENGLISH_ONLY ? 'Service' : 'Service / Bedienung';
const correctionDefaultName = POSITION_NAMES_ENGLISH_ONLY ? 'Correction' : 'Correction / Korrektur';

const measurementProtocols = {
  value: TypeNameEnum.MeasurementProtocols,
  label: 'Measurement Protocols',
  defaultName: '',
  children: [
    {
      value: 'standard',
      label: 'Standard Measurement Protocol',
      defaultName: 'Standard Measurement Protocol',
    },
    {
      value: 'fair',
      label: 'First Article Inspection Report (FAIR)',
      defaultName: 'First Article Inspection Report (FAIR)',
    },
    {
      value: 'cmm',
      label: 'CMM Report',
      defaultName: 'CMM Report',
    },
  ],
};

const otherService = {
  value: TypeNameEnum.Other,
  label: 'Other',
  defaultName: '(please specify)',
};

const materialService = {
  value: TypeNameEnum.Material,
  label: 'Material',
  defaultName: 'Material',
};

const transportService = {
  value: TypeNameEnum.Transport,
  label: 'Transport',
  defaultName: 'Transportation cost',
};

const partsService = {
  value: TypeNameEnum.Parts,
  label: 'Parts',
  defaultName: 'Produced parts',
};

const discountService = {
  value: TypeNameEnum.Discount,
  label: 'Discount',
  defaultName: 'Discount (please specify)',
};

const customClearanceService = {
  value: TypeNameEnum.CustomClearance,
  label: 'Custom Clearance',
  defaultName: 'Custom clearance',
};

const correctionService = {
  value: TypeNameEnum.Correction,
  label: 'Correction',
  defaultName: 'Correction (please specify)',
};

const serviceService = {
  value: TypeNameEnum.Service,
  label: 'Service',
  defaultName: 'Service (please specify)',
};

export const packagingService = {
  value: TypeNameEnum.Packaging,
  label: 'Packaging',
  defaultName: packagingDefaultName,
};

export const imToolsService = {
  value: TypeNameEnum.ImTools,
  label: 'Molds',
  defaultName: 'Molding Tool',
};

export const xpointsService = {
  value: 'x_points',
  label: 'X-points order payment',
  defaultName: 'Loyalty Discount via X-points',
};

interface Service {
  value: string;
  label: string;
  defaultName: string;
  children?: Service[];
}

export const OCServices: Service[] = [
  {
    ...packagingService,
    defaultName: packagingDefaultName,
  },
  {
    ...transportService,
    defaultName: transportDefaultName,
  },
  {
    ...customClearanceService,
    defaultName: customClearanceDefaultName,
  },
  {
    value: TypeNameEnum.Coupon,
    label: 'Coupon',
    defaultName: 'Coupon code (please specify)',
  },
  discountService,
  {
    value: TypeNameEnum.DiscountPrepay,
    label: 'Prepay Discount',
    defaultName: 'Prepay Discount',
  },
  {
    value: TypeNameEnum.MinOrderCharge,
    label: 'Min Order Charge',
    defaultName: minOrderChargeDefaultName,
  },
  certificates,
  measurementProtocols,
  {
    ...serviceService,
    defaultName: serviceDefaultName,
  },
  {
    ...correctionService,
    defaultName: correctionDefaultName,
  },
  materialService,
  otherService,
  imToolsService,
  xpointsService,
];

export interface OIOption {
  value: TypeNameEnum | ServiceType;
  label: string;
  defaultName: string;
  children?: Array<{
    value: string;
    label: string;
    defaultName?: string;
  }>;
}

export const OIServices: OIOption[] = [
  {
    ...packagingService,
    defaultName: packagingDefaultName,
  },
  {
    ...transportService,
    defaultName: transportDefaultName,
  },
  {
    ...customClearanceService,
    defaultName: customClearanceDefaultName,
  },
  {
    value: TypeNameEnum.Coupon,
    label: 'Coupon',
    defaultName: 'Coupon code (please specify)',
  },
  discountService,
  {
    value: TypeNameEnum.DiscountPrepay,
    label: 'Prepay Discount',
    defaultName: 'Prepay Discount',
  },
  {
    value: TypeNameEnum.MinOrderCharge,
    label: 'Min Order Charge',
    defaultName: minOrderChargeDefaultName,
  },
  certificates,
  measurementProtocols,
  {
    ...serviceService,
    defaultName: serviceDefaultName,
  },
  {
    ...correctionService,
    defaultName: correctionDefaultName,
  },
  materialService,
  otherService,
  partsService,
  imToolsService,
];

export const POServices = [
  packagingService,
  transportService,
  customClearanceService,
  discountService,
  certificates,
  measurementProtocols,
  serviceService,
  correctionService,
  materialService,
  otherService,
  imToolsService,
];
